module.exports = __webpack_public_path__ + "static/media/team-2.3c241018.jpg";